// src/features/profile/profileSlice.js
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';

// API Functions
// const API_URL = process.env.REACT_APP_API_URL;

const fetchProfileData = async () => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.get(`${process.env.REACT_APP_API_URL}/me`, {
      headers: {
        Authorization: token, // Ensure correct header format
      },
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching profile data:",
      error.response ? error.response.data : error.message
    );
    throw new Error(
      "Failed to fetch profile data: " +
        (error.response ? error.response.data.message : error.message)
    );
  }
};

const updateProfile = async (formData) => {
  try {
    const token = localStorage.getItem("token");
    const response = await axios.patch(
      `${process.env.REACT_APP_API_URL}/update/profile`,
      formData,
      {
        headers: {
          Authorization: token, // Include the token in the request headers
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Error updating profile data:",
      error.response ? error.response.data : error.message
    );
    throw new Error(
      "Failed to update profile: " +
        (error.response ? error.response.data.message : error.message)
    );
  }
};

// Thunks
export const fetchProfile = createAsyncThunk('profile/fetchProfile', async () => {
  const response = await fetchProfileData();
  return response;
});

export const updateProfileData = createAsyncThunk(
  'profile/updateProfile',
  async (profile, { rejectWithValue }) => {
    try {
      const response = await updateProfile(profile);
      return response;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Slice
const profileSlice = createSlice({
  name: 'profile',
  initialState: {
    profileData: null,
    status: 'idle',
    error: null,
  },
  reducers: {
    clearError: (state) => {
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchProfile.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchProfile.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.profileData = action.payload;
      })
      .addCase(fetchProfile.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(updateProfileData.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(updateProfileData.fulfilled, (state, action) => {
        state.status = 'succeeded';
        state.profileData = { ...state.profileData, ...action.payload };
      })
      .addCase(updateProfileData.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.payload;
      });
  },
});

export const { clearError } = profileSlice.actions;
export default profileSlice.reducer;
